import { useApiQueryWithAtom } from "@/api/hooks/useApiQuery/useApiQueryWithAtom";
import {
    getBalanceSheet,
    getIncomeStatement,
    getMetricsByResolution,
} from "@/entities/Finance/Finance.queries";
import { AccountLabel } from "@/entities/Labeling/Account.model";
import { metricsAtom } from "./state/Metrics.state";
import { getFinanceLabMetricsByResolution } from "@/entities/FinanceLab/FinanceLab.queries";
import { FinanceLabField } from "@/entities/FinanceLab/FinanceLab.model";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import {
    balanceSheetAtom,
    financeMetricsAtom,
    finLabMetricsAtom,
    incomeStatementAtom,
} from "./state/MetricQueries.state";

export function useMetricHydration(
    metricList: AccountLabel[],
    finLabMetricList: FinanceLabField[],
) {
    useApiQueryWithAtom(getIncomeStatement, incomeStatementAtom);
    useApiQueryWithAtom(getBalanceSheet, balanceSheetAtom);
    useApiQueryWithAtom(getMetricsByResolution, financeMetricsAtom, {
        params: {
            labels: metricList,
        },
    });

    useApiQueryWithAtom(getFinanceLabMetricsByResolution, finLabMetricsAtom, {
        params: {
            labels: finLabMetricList,
        },
    });

    const metrics = useAtomValue(metricsAtom);

    useEffect(() => {
        (window as any).metrics_utils = {
            metrics: metrics.data,
        };
    }, [metrics]);

    return metrics;
}
